<div class="col-md-12">
  <ul class="sc__tab-selector">
    <li class="sc__tab" *ngFor="let item of items" [ngClass]="{ 'sc__tab--selected': selectedTab.id === item.id }">
      <button class="sc__tab-button" (click)="handleTabClick(item)" [disabled]="item.disabled">{{ item.label }}</button>
    </li>
  </ul>
</div>